module.exports = __webpack_public_path__ + "img/recharge.dd2a7be2.png";